export const appKeysConfig = {
  TOKEN: 'FRANCE_VICTIMES_TOKEN_CLIENT',
  USER_ACTIONS: 'FRANCE_VICTIMES_USER_ACTIONS_CLIENT',
  ALLOCATION: 'FRANCE_VICTIMES_ALLOCATION_CLIENT',
};

export enum Status {
  SUCCESS = 1,
  FAIL = 0,
}

export const RECORDS_PER_PAGE = 10;
